import { Component, Input } from '@angular/core';
import { Entry } from 'contentful';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { ProfileService } from '../../services/profile/profile.service';
import { FindResourcePipe } from '../../pipes/find-resource/find-resource.pipe';

@Component({
  selector: 'app-settings-your-information',
  templateUrl: './settings-your-information.component.html',
  styleUrls: ['./settings-your-information.component.scss']
})
export class SettingsYourInformationComponent {
  @Input() public content: Entry<any> | undefined;
  public user$ = this.profileService.user();
  public edit: boolean = false;
  public delete: boolean = false;
  public basicInformation = new FormGroup({
    firstName: new FormControl(null, [Validators.required]),
    lastName: new FormControl(null, [Validators.required]),
    email: new FormControl(null, [Validators.required, Validators.email])
  });

  public error: string = '';
  public loading: boolean = false;
  public deleting: boolean = false;
  public deleteError: string = '';
  public deleted: boolean = false;

  constructor(
    private profileService: ProfileService,
    private findResourcePipe: FindResourcePipe
  ) {}

  async onEdit() {
    const userSnapshot = await this.user$.pipe(first()).toPromise();
    this.basicInformation.reset(userSnapshot);
    this.edit = true;
  }

  async onDelete() {
    this.delete = true;
  }

  updateProfile() {
    if (this.basicInformation.valid && !this.loading) {
      this.loading = true;
      this.profileService
        .updateUserInfo(this.basicInformation.value)
        .then(response => {
          this.loading = false;
          if (response.code === 'auth/requires-recent-login') {
            this.error = this.findResourcePipe.transform(
              this.content.fields.resources,
              'settings.requiresRecentLoginErrorMessage'
            );
          } else if (response.code === 'auth/email-already-in-use') {
            this.error = this.findResourcePipe.transform(
              this.content.fields.resources,
              'settings.emailAlreadyInUseErrorMessage'
            );
          } else if (!response.updated) {
            this.error = this.findResourcePipe.transform(
              this.content.fields.resources,
              'settings.updateFailedErrorMessage'
            );
          } else {
            this.edit = false;
          }
        })
        .catch(error => {
          console.error(error);
          this.loading = false;
        });
    }
  }

  deleteAccount() {
    this.deleting = true;
    this.deleteError = '';
    this.profileService
      .deleteUserInfo()
      .then(response => {
        this.deleting = false;
        this.deleted = response.deleted;
        if (response.code === 'auth/requires-recent-login') {
          this.deleteError = this.findResourcePipe.transform(
            this.content.fields.resources,
            'settings.requiresRecentLoginErrorMessage'
          );
        } else {
          this.delete = false;
        }
      })
      .catch(error => {
        console.error(error);
        this.deleting = false;
      });
  }
}
